import React, { Component } from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

import s from "./style.module.scss";

class GaddPart extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      // 初始state
      index: 0,
      opacity: 1,
      showAnimation: false,
    };
    this._handleScroll = this.handleScroll.bind(this);
  }
  componentDidMount() {
    window.addEventListener("scroll", this._handleScroll);
    // 初始检查一次位置
    this._handleScroll();
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this._handleScroll);
  }
  handleScroll() {
    const clientHeight = document.documentElement.clientHeight;
    const gooseAddPartRect = this.refs.goose_add_part.getBoundingClientRect();

    // 当元素的顶部进入视口60%时触发动画
    if (
      gooseAddPartRect.top < clientHeight * 0.6 &&
      !this.state.showAnimation
    ) {
      this.setState({ showAnimation: true });
    }
  }
  render() {
    const { locale } = this.props;
    const { showAnimation } = this.state;

    return (
      <div
        className={
          locale.includes("US")
            ? s.goose_add_part_en
            : locale.includes("TW")
            ? s.goose_add_part_tw
            : s.goose_add_part
        }
        ref="goose_add_part"
      >
        <div className={s.anchor} id="mi"></div>
        <div
          className={`${s.top_text} ${showAnimation ? s.animateIn : s.hidden}`}
          ref="top_text"
        >
          <div
            className={
              locale.indexOf("US") > -1
                ? s.mi_icon_en : s.mi_icon
            }
          ></div>
          <h1>
            <FormattedMessage
              id="gs3_five_title"
              values={{
                sup: (
                  <sup className={s.footnote}>
                    <a href="#footnote-1" aria-label="脚注1">
                      1
                    </a>
                  </sup>
                ),
              }}
            />
          </h1>

          <p>
            <FormattedMessage id="gs3_five_desc"></FormattedMessage>
          </p>
        </div>

            <div className={s.image}></div>
            <div className={s.image2}></div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  locale: state.language,
});

const GAddPart = connect(mapStateToProps)(GaddPart);

export default GAddPart;
